import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Update alert
 *
 * @private
 */
export const updateAlert = createAsyncThunk<
  // Return type of the alertIds creator
  void,
  // First argument to the alertIds creator
  uui.domain.client.gps.wwgps.EventAlert,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/alert/update', async (alert, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/alert/update', {
      category: 'rpc',
      type: 'rpc/alert/update',
      alert,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateAlert}`,
      { tags: ['rpc', 'alert'], info: alert },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Update alert failed',
      error,
    })
  }
})
